module.exports = __webpack_public_path__ + "img/Teixeira_de_Carvalho@2x.6bb6829a.png";